export default (context) => {
    context.time.total = context.timestamp - new Date().getTime()

    let seconds = Math.floor((context.time.total / 1000) % 60);
    if(seconds >= 10) {
        context.time.seconds = seconds
    } else {
        context.time.seconds = `0${seconds}`
    }
    let minutes = Math.floor((context.time.total / 1000 / 60) % 60);
    if(minutes >= 10) {
        context.time.minutes = minutes
    } else {
        context.time.minutes = `0${minutes}`
    }

    if(context.time.total >= 0) {
        setTimeout(() => {
            context.auth_counter_time(context)
        }, 1000)
    } else {
        context.time.seconds = '00'
        context.time.minutes = '00'
    }
}